import type { ISODateTime } from './Common';

export const DEFAULT_REASON = 'NONE';

// ===== Response types ===== //

export interface DeleteCancellationResponse {
  id?: string;
  subscriptionId?: string;
  status: CancellationStatus;
  effectiveDate: ISODateTime;
  type?: CancellationType;
  eligibleForRefund?: boolean;
  reason?: string;
  requestedBy?: RequestedBy;
}

export type CancellationResponse = Pick<Cancellation, 'status' | 'effectiveDate'>;

export interface Cancellation {
  id: string;
  type: CancellationType;
  status: CancellationStatus;
  effectiveDate: ISODateTime;
}

export type CancellationStatus = 'PENDING'| 'FAILED'| 'CANCELLED'| 'COMPLETED';
export type CancellationType = 'IMMEDIATE' | 'IMMEDIATE_NO_REFUND' | 'START_OF_TERM' | 'END_OF_QUOTA'| 'END_OF_COMMITMENT';
export type CancellationEligibility = Extract<CancellationType, 'IMMEDIATE' | 'IMMEDIATE_NO_REFUND' | 'END_OF_COMMITMENT'>;

// ===== Payload types ===== //

export interface CancellationPayload {
 reason: string,
 reason_text?: string,
 requested_by: RequestedBy,
 type: CancellationType
}

type RequestedBy = 'end_user' | 'agent' | 'support_team';